module.exports = __webpack_public_path__ + "82fa1492a9779546bc57b3b5998b836d.pdf";